import { Controller } from "@hotwired/stimulus"
import { FormHelper } from "~/helpers/form_helper"

export default class extends Controller {
  static targets = ["description"]

  static values = {
    attributeId: String,
  }

  submit(event) {
    event.preventDefault()

    const description = this.descriptionTarget.value

    if (!description) {
      this.descriptionTarget.classList.add("error")
      FormHelper.displayFlashError(i18n.t("js.back.custom_attribute.error.empty_description"))
      return
    }

    fetch(`/leads/custom-attributes/${this.attributeIdValue}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]')?.content,
      },
      body: JSON.stringify({
        lead_custom_attribute: {
          description: description,
        },
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.text()
        }
        throw new Error(response.statusText)
      })
      .then((html) => {
        Turbo.renderStreamMessage(html)
        this.element.closest(".dropdown-menu").previousElementSibling.click()
      })
      .catch((error) => {
        console.error("Error:", error)
        this.descriptionTarget.classList.add("error")
        FormHelper.displayFlashError(i18n.t("js.leads.custom_attribute.error.saving"))
      })
  }
}
